import React, {useState, useEffect, useRef, useContext} from 'react';
import { translateCol } from "../../../custom/columnI18n";
import { useTranslation } from "react-i18next";

import { useSelector } from 'react-redux';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { TabMenu } from 'primereact/tabmenu';
import { AuthContext } from "../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import CustomDropdown from '../../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const DnevniceHome = () => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const user = useSelector(state => state.user)
        const [selectedRowIdWage , setSelectedRowIdWage] = useState(null);
        const isSelected = (row) => String(getIdWage(row)) === String(selectedRowIdWage);
        const [drzaveOptions, setDrzaveOptions] = useState([])
        const [valuteOptions, setValuteOptions] = useState([])
        const [izabran, setIzabran] = useState(false)
        const [idWage, setIdWage] = useState(null)
        const [popuni, setPopuni] = useState(false)
        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
        const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
        const [porukaTimeRange, setPorukeTimeRange] = useState(null)
        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdWage = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

         const [formDataWages, setFormDataWages] = useState({
        id_drzava: null,
        valuta: null,
        iznos: null,
        vaziOd: null,
        vaziDo: null,
        napomena: ''
        });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_izabrali_karticu_da_bi_popunili_po'),
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetWage", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                               
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesno_popunjavanje_podataka_dnevnice'),
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormDataWages({
        id_drzava: apiData[0].id_drzava || null,
        valuta: apiData[0].valuta || null,
        iznos: apiData[0].iznos || null,
        vaziOd: apiData[0].vaziOd ? new Date(apiData[0].vaziOd) : null,
        vaziDo: apiData[0].vaziDo ? new Date(apiData[0].vaziDo) : null,
        napomena: apiData[0].napomena || ''
      });
};

   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              }
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetWagesAndTypes", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                setDrzaveOptions(parsedData.DrzaveDB)
                                setValuteOptions(parsedData.ValuteDB)
                                setTableData(parsedData.WagesDB)


                                 if (parsedData.WagesDB && parsedData.WagesDB.length > 0) {
                                                const columns = Object.keys(parsedData.WagesDB[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                  const originalOrder = Object.keys(parsedData.WagesDB[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[formSubmitted])



const resetData = ()=> {
        setFormDataWages({
            id_drzava: null,
            valuta: null,
            iznos: null,
            vaziOd: null,
            vaziDo: null,
            napomena: ''
        });
}
const handleDeleteFuncCard = () => {
       
            confirmDialog({
            message: "Želite obrisati dnevnicu?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {
 
  if (idWage) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idWage
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/finance/DeleteWage", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: t('admin.m_uspesno_brisanje_dnevnice'),
                life: 3000,
                });
                resetData()
                setIdWage(null)
                setSelectedRowIdWage(null)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: t('admin.m_niste_izabrali_karticu_za_brisanje'),
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  
              //DATA
                  const hasAnyValueWages = Object.values(formDataWages).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formDataWages,
                        vaziOd: toUtcIso(formDataWages.vaziOd),
                        vaziDo: toUtcIso(formDataWages.vaziDo)
                        };

                  if(izabran && idWage){
                 if(hasAnyValueWages){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idWage),
                                formDataWages: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/UpdateWage", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima dnevnice.' && data[0].message != 'Uspešna izmena!' 
                                        && data[0].message != 'Izmena nije moguća: period se preklapa sa postojećom dnevnicom za istu državu.' && !data[0].message.includes('Rupa u kontinuitetu!')){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message && (data[0].message == 'Nema izmena u podacima dnevnice.' || data[0].message == 'Izmena nije moguća: period se preklapa sa postojećom dnevnicom za istu državu.' || data[0].message.includes('Rupa u kontinuitetu!'))){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                return
                               }

                                toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesna_izmena_podataka_dnevnice'),
                                life: 3000,
                                });
                           
                                setFormSubmitted(false)
                                
                                setIdWage(null)
                                setSelectedRowIdWage(null)
                                setIzabran(false)
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_dnevnice'),
                        life: 3000,
                    });
                }
           
           
                } else {
                  if(hasAnyValueWages){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  formDataWages: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/InsertWage", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                  if(data) {
                                        if(data.message != 'Postoji aktivna dnevnica za ovu državu čiji se period preklapa!' && data.message != 'Uspešan unos dnevnice!'){
                                        toast.current.show({
                                        severity: "error",
                                        summary: "Error",
                                        detail: data.message,
                                        life: 3000,
                                        });
                                        return
                                        } else if (data.message == 'Postoji aktivna dnevnica za ovu državu čiji se period preklapa!') {
                                              toast.current.show({
                                                severity: "warn",
                                                summary: t('admin.m_upozorenje_2'),
                                                detail: data.message,
                                                life: 3000,
                                            });
                                            return
                                        }
                                  }
                                  
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: t('admin.m_uspesan_unos_podataka_dnevnice'),
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: t('admin.m_upozorenje_2'),
                          detail: t('admin.m_niste_popunili_podatke_dnevnice_za_unos'),
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formDataWages) {
            if(name === 'vaziDo' && formDataWages.vaziOd != null && (formDataWages.vaziOd >= value)) {
                setFormDataWages(prev => ({ ...prev, vaziDo: null }));
                setPorukeTimeRange('Datum OD ne može biti veći od datuma DO!')
                return
            } else {
                if(porukaTimeRange != null)
                    setPorukeTimeRange(null)
            }
        setFormDataWages(prev => ({ ...prev, [name]: value }));
        }
    };
  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Dnevnice');
  
      const headers = selectedColumns.map(c => translateCol(t, c));

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Dnevnice - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
  const header = (
    <div className="export-buttons fakture-stavke-header">
      <div className="fakture-stavke-radnje">
        <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
        {selectedRowIdWage && (
          <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncCard} data-pr-tooltip={t('common.delete')} />
        )}
      </div>
      <input
        type="search"
        onInput={(e) => setGlobalFilter(e.target.value)}
        placeholder={t('nova.phPretraga')}
        className="p-inputtext p-component"
      />
    </div>
  );

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseWage = (rowData) => {
        const id = getIdWage(rowData);

        setSelectedRowIdWage((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdWage(next)
        popuniRedove(id)
        setIzabran(true) 
        }
        else {
        setIdWage(null)
        resetData()
        setIzabran(false) 
        }

        return next;
    });
    }

     const previewBodyTemplateWage = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseWage(rowData)}
              />
            
        </div>
      );
    };

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />        

        <ConfirmDialog />
            <div className='col-12'>
                          <div className='blagajnaDashboard dnevniceDashboard'>
                             <Card>
                            <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                            <div className="gridLicni">
                                <div className="col-12 md:col-6">
                                        <label htmlFor="vaziOd">{t('ture.vaziOd')}:</label>
                                        <Calendar required invalid={invalidControl(formDataWages.vaziOd)} id="vaziOd" name="vaziOd" value={formDataWages.vaziOd} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                        <label htmlFor="vaziDo">{t('ture.vaziDo')}:</label>
                                        {porukaTimeRange && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaTimeRange}</p>}
                                        <Calendar required invalid={invalidControl(formDataWages.vaziDo)} id="vaziDo" name="vaziDo" value={formDataWages.vaziDo} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_drzava">{t('ture.drzava')}:</label>
                                            <CustomDropdown
                                                 id="id_drzava" 
                                                 name="id_drzava" 
                                                 value={formDataWages.id_drzava} 
                                                 options={drzaveOptions || []}
                                                 placeholder={t('nova.phDrzavu')}
                                                 required
                                                    invalid={invalidControl(formDataWages.id_drzava)}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                               <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="valuta">{t('nova.valuta')}:</label>
                                            <CustomDropdown
                                                 id="valuta" 
                                                 name="valuta" 
                                                 value={formDataWages.valuta} 
                                                 options={valuteOptions || []}
                                                 placeholder={t('nova.phValutu')}
                                                 required
                                                 invalid={invalidControl(formDataWages.valuta)}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                    <label htmlFor="iznos">{t('nova.iznos')}:</label>
                                    <InputNumber
                                    id="iznos" 
                                    name="iznos" 
                                    value={formDataWages.iznos} 
                                    required
                                    invalid={invalidControl(formDataWages.iznos)}
                                    onValueChange={handleChange} 
                                    minFractionDigits={2} maxFractionDigits={2} />
                                </div>
                              <div className="col-12 md:col-6 maxWidthInput" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="napomena">{t('nova.napomena')}:</label>
                                            <InputText 
                                                id="napomena"
                                                name="napomena"
                                                value={formDataWages.napomena} 
                                                onChange={handleChange}
                                                />
                              </div>

                            </div>
                            <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", marginTop:'2%'}} className="btn btn-success">
                                {izabran ? "SAČUVAJ" : "UNOS"}
                            </button>
                            </div>
                            </form>
                          </Card>
                          <Card>
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                   <DataTable
                                          value={tableData || []}
                                          paginator
                                          rows={10}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight="50vh"
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={translateCol(t, colMeta?.label || colKey)}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplateWage(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                          </Card>
                          </div>
            </div>                                

       </div>
)
}

export default DnevniceHome;